<div class="content-wrapper-inner relative">
  <app-disabled-section-widget [service]="'ntc'" (changeState)="serviceDisabled = !$event.service"></app-disabled-section-widget>
  <div *ngIf="serviceDisabled === false" class="page-content">
    <div class="table-topbar">
      <div class="search-holder">
        <h3>Reports</h3>
      </div>
    </div>
    <app-scheduler-reports-search (onSubmit)="onSubmitSearchForm($event)"></app-scheduler-reports-search>
  </div>
  <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative" *ngIf="serviceDisabled === false">
    <app-scheduler-reports-table></app-scheduler-reports-table>
  </div>
</div>
